"use strict";var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VComponent(component, key, ownerComponent, preserve) {
  this.bV_(null /* childCount */, ownerComponent);
  this.bY_ = key;
  this.s_ = component;
  this.ad_ = preserve;
}

VComponent.prototype = {
  bX_: 2
};

inherit(VComponent, VNode);

module.exports = VComponent;